var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{staticClass:"content-sm"},[_c('Content',[_c('h2',[_c('Icon',{attrs:{"type":"ios-people"}}),_vm._v("\n      Sezione Utenti\n    ")],1),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }